import { useEffect, useState } from 'react';
import { useRealtime } from '../realtime/RealtimeProvider';

/** Ennyi ideig nem szolunk: egy rovid szakadas (alagut, wifi-valtas) ne villogjon. */
const QUIET_FOR_MS = 3_000;

/**
 * KAPCSOLAT-ALLAPOT a beszelgetes felett - telefonon (versenyaudit K2).
 *
 * Asztalon az oldalsav jelzi (ConnectionPill), telefonon viszont a
 * beszelgetes nezeteben az oldalsav nem latszik. Ott eddig semmi nem mondta
 * meg, hogy az uzenetek eppen nem jonnek - az ember azt hitte, csend van.
 */
export function ConnectionBanner() {
  const { status } = useRealtime();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (status === 'online') {
      setShown(false);
      return;
    }
    const timer = window.setTimeout(() => setShown(true), QUIET_FOR_MS);
    return () => window.clearTimeout(timer);
  }, [status]);

  const label =
    status === 'unauthorized'
      ? 'Lejárt a belépés – lépj be újra.'
      : status === 'connecting'
        ? 'Kapcsolódás…'
        : 'Nincs kapcsolat – újrapróbálkozás…';

  return (
    <div role="status" className="md:hidden">
      {shown && status !== 'online' && (
        <p className="border-b border-border-soft bg-alert-soft px-4 py-1.5 text-center text-xs font-medium text-alert">
          {label}
        </p>
      )}
    </div>
  );
}
